import { Avatar, CardContent, Grid, Stack, Typography } from '@mui/material';
import { MprcClickable, MprcContainer, MprcJoinComponents, MprcSpinnerIndicator } from 'components';
import { LearnPathViewPhaseDto } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    trainingId: string;
}

export const LearnPathPhasesView: React.FC<IProps> = (props) => {

    const { trainingId } = props;

    const { t } = useTranslation("lms");
    const api = useCoreApi();

    const [viewData, setViewData] = useState<LearnPathViewPhaseDto[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const loadData = () => {
        api.v1.lmsTraining.getLearnPathPhasesView({ trainingId })
            .then(response => setViewData(response.data))
            .catch(e => alert(e))
            .finally(() => setLoading(false));
    };

    // Visualizar publicação.
    const viewerClick = (trainingId: string) => {
    };

    useEffect(() => {
        loadData();
    }, []);

    return loading
        ? <MprcSpinnerIndicator />
        :
        <>
            {viewData
                .map(
                    (phase, index) =>
                        <MprcContainer key={phase.phaseId} margin={index + 1 === viewData.length ? "none" : "dense"}>
                            <Typography noWrap={true} variant="h3">{phase.title}</Typography>
                            <Typography component="div" noWrap={true} variant="caption">
                                {t("Training.LearnPathPhases.ModuleText", { count: phase.components.length })}
                            </Typography>
                            <CardContent>
                                <Stack direction="column" gap={1}>
                                    {
                                        phase.components.map((item, i) => {
                                            return (
                                                <Grid
                                                    key={i}
                                                    container
                                                    spacing={1}
                                                    alignItems="flex-start"
                                                    justifyContent="flex-start"
                                                    wrap="nowrap"
                                                >
                                                    <Grid>
                                                        <MprcClickable onClick={() => viewerClick(item.trainingId)}>
                                                            <Avatar
                                                                variant="rounded"
                                                                sx={{ width: 120, height: 68 }}
                                                                src={item.thumbnailUrl}
                                                            />
                                                        </MprcClickable>
                                                    </Grid>
                                                    <Grid size="grow">
                                                        <MprcClickable onClick={() => viewerClick(item.trainingId)}>
                                                            <MprcJoinComponents
                                                                components={[
                                                                    <Typography variant="caption">{item.contentTypeStr}</Typography>
                                                                    , <Typography variant="caption">{item.trainingDurationFormated}</Typography>
                                                                ]}
                                                                separator={<span>&nbsp;&bull;&nbsp;</span>}
                                                            />
                                                            <br />
                                                            <Typography variant="body1" fontWeight="bold">{item.title}</Typography>
                                                        </MprcClickable>
                                                    </Grid>
                                                </Grid>
                                            );
                                        })
                                    }
                                </Stack>
                            </CardContent>
                        </MprcContainer>
                )
            }
        </>;
};
